module.exports = __webpack_public_path__ + "static/img/par3.4c5eb6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_game/par3.png
// module id = 4t9o
// module chunks = 0